import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
	Form,
	Row,
	Col,
	Card,
	Badge,
	notification,
	Tag,
	Spin,
	Space,
	Divider,
	Button,
} from "antd";
import { FormOutlined } from "@ant-design/icons";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import approvalService from "../../services/approver";
import CommentSystem from "../../components/comment";
import CreatedByComponent from "../../components/commonDetails/createdBy";
import ApproversComponent from "../../components/commonDetails/approvers";
import ApproveDisapproveComponent from "../../components/commonDetails/approveDisapprove";
import TaskStatus from "../../components/commonDetails/taskStatus";
import FeedbackModal from "../../components/feedbackModal";
import { replaceLineBreaks } from "../../utils/helper";

import sapService from "../../services/sap";

// FOR IMAGE
import { getFileNameFromPath, downloadFile } from "../../utils/helper";

import AddApproversComponent from "../../components/commonDetails/manageApprovers";
import { useSelector } from "react-redux";
import TaskModal from "../../components/taskModal";
// import department from "../../services/department";

const SapDetails = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();
	const [status, setStatus] = useState(null);
	const { id } = useParams();
	const [assignedUserId, setAssignedUserId] = useState(null);
	const navigate = useNavigate();
	const [formId] = useState(7);
	const { currentUser } = useSelector((state) => state.user);

	// PRINT STYLES & PRINT HANDLER
	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #qqq{
          display:none;
        }
        #ppp, #ppp * {
          visibility: visible;
        }
        #ppp {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    `;
		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, []);
	// PRINT STYLES & PRINT HANDLER

	const [isPrintable, setIsPrintable] = useState(false);
	const handlePrintClick = () => {
		setIsPrintable(true);
		setTimeout(() => {
			window.print();
			setIsPrintable(false);
		}, 100);
	};

	const getSapById = async () => {
		setLoading(true);
		await sapService
			.getSapById(id)
			.then((response) => {
				console.log("response");
				console.log(response);
				console.log("response");
				setData(response);
				setLoading(false);
			})
			.catch((error) => {
				navigate("/sap-access-form");
			});
	};

	useEffect(() => {
		getSapById();
	}, []);

	const handleSubmit = async (values, isParallel) => {
		setLoading(true);
		const formattedValues = {
			status,
			approved_disapproved: false,
			form_id: 7,
			key: parseInt(id),
			reason: values.message,
			...(isParallel && { assigned_user_id: assignedUserId }),
		};

		const serviceMethod = isParallel
			? approvalService.updateParallelStatus
			: approvalService.updateStatus;

		try {
			const response = await serviceMethod(formattedValues);
			if (response.success) {
				notification.success({
					message: "Status",
					description: response.message,
				});
				form.resetFields();
				getSapById(id);
				navigate("/dashboard");
			}
		} catch (error) {
			notification.error({
				message: "Error",
				description: error.response?.data?.message || "An error occurred",
			});
		} finally {
			setLoading(false);
		}
	};

	// Comment Condition Updated
	let canComment = 0;
	if (data) {
		if (data.status !== "Approved" && data.status !== "Return") {
			canComment = 1;
		} else {
			if (data.comment_status === 1) {
				canComment = 1;
			}
		}
	}

	const locationOptions = [
		{ id: 1, name: "Head Office" },
		{ id: 2, name: "Karachi Plant" },
		{ id: 3, name: "Pezu Plant" },
		{ id: 4, name: "Area Office" },
		{ id: 5, name: "Islamabad" },
		{ id: 6, name: "Lahore" },
		{ id: 7, name: "Peshawar" },
		{ id: 8, name: "Multan" },
		{ id: 9, name: "Faisalabad" },
		{ id: 10, name: "Quetta" },
	];
	const plantOptions = [
		{ id: 1, name: "PIBT" },
		{ id: 2, name: "QICT" },
		{ id: 3, name: "LCHO" },
		{ id: 4, name: "LCKP" },
		{ id: 5, name: "LCPZ" },
		{ id: 6, name: "LKPT" },
		{ id: 7, name: "PKGP" },
		{ id: 8, name: "PGPZ" },
	];
	// Comment Condition Updated
	const Isadmin = currentUser.roles.includes("admin");

	//  For hiding next hierarchy to the user
	// let filteredApprovers = [];
	// if(data){
	//   const allApprovers = data.approvers;

	//   if (Array.isArray(allApprovers)) {
	//         filteredApprovers = allApprovers.map(approver => ({
	//           ...approver,
	//           users: approver.users ? approver.users.filter(user => user.status === 'Processing') : []
	//       }));

	//     console.log('filteredApprovers');
	//       console.log(filteredApprovers);
	//   } else {
	//       console.error("allApprovers is not defined or is not an array.");
	//   }
	// }

	//  const renderSection = (title, items, fields) => {
	//   if (!items || items.length === 0) return null;

	//   return (
	//   <Card title={title} className="mb-10">
	//     {items.map((item, index) => (
	//       <Row gutter={[16, 16]} className="mt-20" key={index}>
	//         {fields
	//           .filter((field) => item[field.key]) // Filter out empty values
	//           .map((field) => (
	//             <Col xs={24} sm={12} md={8} lg={6} xl={6} key={field.key}>
	//               <p className="fs-12 mb-10 bold">{field.label}</p>
	//               <Tag style={{ width: "80%" }}>{item[field.key]}</Tag>
	//             </Col>
	//           ))}
	//       </Row>
	//     ))}
	//   </Card>
	//   );
	// };
	// const renderSection = (title, items, fields) => {
	//     if (!items || items.length === 0) return null;

	//     // Filter out items that have all null values
	//     const validItems = items.filter(item =>
	//       fields.some(field => item[field.key] !== null && item[field.key] !== 'null' && item[field.key] !== "")
	//     );

	//     if (validItems.length === 0) return null; // Hide section if no valid items remain

	//     // console.log('Label',validItems);
	//     console.log('validItems',validItems,'--->',title);
	//     return (
	//       <Card title={title} className="mb-10">
	//         {validItems.map((item, index) => (
	//           <Row gutter={[16, 16]} className="mt-20" key={index}>
	//             {fields
	//               .filter(field => item[field.key]) // Show only non-null values
	//               .map(field => (
	//                 <Col xs={24} sm={12} md={8} lg={6} xl={6} key={field.key}>
	//                   <p className="fs-12 mb-10 bold">{field.label}</p>
	//                   <Tag style={{ width: "80%" }}>{item[field.key]}</Tag>
	//                 </Col>
	//               ))}
	//           </Row>
	//         ))}
	//       </Card>
	//     );
	//   };

	const renderSection = (title, items, fields) => {
		if (!items || items.length === 0) return null;

		// Filter out items that have all null, empty, or undefined values
		const validItems = items.filter((item) =>
			fields.some((field) => {
				const value = item[field.key];
				return (
					value !== null &&
					value !== "null" &&
					value !== "" &&
					value !== undefined
				);
			})
		);

		if (validItems.length === 0) return null; // Hide section if no valid items remain

		console.log("validItems", validItems, "--->", title);
		return (
			<Card title={title} className='mb-10'>
				{validItems.map((item, index) => (
					<Row gutter={[16, 16]} className='mt-20' key={index}>
						{fields
							.filter((field) => {
								const value = item[field.key];
								return (
									value !== null &&
									value !== "null" &&
									value !== "" &&
									value !== undefined
								);
							})
							.map((field) => {
								const value = item[field.key];
								return (
									<Col xs={24} sm={12} md={12} lg={12} xl={12} key={field.key}>
										<p className='fs-12 mb-10 bold'>{field.label}</p>
										<div
											style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
										>
											{Array.isArray(value) ? (
												value.map((val, i) => (
													<Tag key={i} style={{ marginBottom: "4px" }}>
														{val}
													</Tag>
												))
											) : (
												<Tag>{value}</Tag>
											)}
										</div>
									</Col>
								);
							})}
					</Row>
				))}
			</Card>
		);
	};

	//  For hiding next hierarchy to the user
	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FormOutlined />} title='SAP Access Form Details' />
				</Col>
			</Row>

			<Spin spinning={loading}>
				{/* PRINTABLE CARD */}
				{isPrintable && (
					<Card
						style={{
							minHeight: "100vh",
							marginLeft: "-200px",
							marginTop: "-50px",
							border: "none",
							padding: 24,
							background: "#fff",
						}}
						id='ppp'
					>
						<Row gutter={[24, 24]}>
							<Col span={24} style={{ textAlign: "center" }}>
								<img
									src={
										currentUser?.company?.logo
											? currentUser.company.logo.replace("/uploads", "")
											: "https://www.lucky-cement.com/wp-content/uploads/2017/02/lucky-logo.png"
									}
									alt='Logo'
									style={{ height: "40px", width: "auto", marginBottom: 16 }}
								/>
								<h2 style={{ marginBottom: 0 }}>
									<strong>SCRF Request Details</strong>
								</h2>
								<div style={{ fontSize: 12, marginBottom: 16 }}>
									<b>Sequence No:</b> {data.sequence_no} &nbsp; | &nbsp;
									<b>Request Title:</b> {data.request_title} &nbsp; | &nbsp;
									<b>Status:</b> {data.status}
								</div>
							</Col>
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<p className='fs-12 mb-10 bold'>Location</p>
								{data?.data?.location?.map((location) => {
									const matchedLocation = locationOptions.find(
										(option) => Number(option.id) === Number(location.id)
									);

									return (
										<Tag key={location.id}>
											{matchedLocation
												? matchedLocation.name
												: "Unknown Location"}
										</Tag>
									);
								})}
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>For Email:</b> <Tag>{data?.for_email}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>For Department:</b> <Tag>{data?.for_department}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>For Designation:</b> <Tag>{data?.for_designation}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>For Employee:</b> <Tag>{data?.for_employee}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Company:</b> <Tag>{data.company?.name}</Tag>
							</Col>
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Type:</b> <Tag>{data.type} (SAP ID)</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Start Date:</b> <Tag>{data.assigned_task?.start_at}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Deadline:</b> <Tag>{data.assigned_task?.due_at}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>For Employee:</b> <Tag>{data?.for_employee}</Tag>
							</Col>
							{data.type && data.type === "Modification" && (
								<Col xs={24} sm={12} md={8} lg={6} xl={6}>
									<p className='fs-12 mb-10 bold'>Current Sap Id</p>
									<Tag>{data.sap_id}</Tag>
								</Col>
							)}
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>Roles Required:</b> <Tag>{data?.roles_required}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<b>T.Code Required:</b> <Tag>{data?.tcode_required}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={6} xl={6}>
								<p className='fs-12 mb-10 bold'>Plant</p>
								{data?.data?.plant?.map((plant) => {
									const matchedPlant = plantOptions.find(
										(option) => Number(option.id) === Number(plant.id)
									);
									return (
										<Tag key={plant.id}>
											{matchedPlant ? matchedPlant.name : "Unknown plant"}
										</Tag>
									);
								})}
							</Col>
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col span={24}>
								<b>Business Justification:</b>
								<div
									style={{ marginTop: 8 }}
									dangerouslySetInnerHTML={{
										__html: replaceLineBreaks(data.request_specs),
									}}
								/>
							</Col>
						</Row>
						<Divider />
						{data && data.attachments && (
							<Row gutter={[16, 16]}>
								<Col span={24}>
									<b>Attachments:</b>
									<table
										style={{
											width: "100%",
											borderCollapse: "collapse",
											marginTop: 8,
										}}
									>
										<thead>
											<tr>
												<th
													style={{
														textAlign: "left",
														padding: 8,
														borderBottom: "1px solid #eee",
													}}
												>
													Title
												</th>
												<th
													style={{
														textAlign: "left",
														padding: 8,
														borderBottom: "1px solid #eee",
													}}
												>
													Preview
												</th>
											</tr>
										</thead>
										<tbody>
											{data.attachments.map((attachment) => {
												const isImage = (filename) =>
													/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
												const fileUrl = attachment.filename;
												const fileTitle =
													attachment.original_title || attachment.filename;
												return (
													<tr key={attachment.id}>
														<td style={{ padding: 8 }}>{fileTitle}</td>
														<td style={{ padding: 8 }}>
															{isImage(fileUrl) ? (
																<img
																	src={fileUrl}
																	alt={fileTitle}
																	style={{
																		width: 40,
																		height: 40,
																		objectFit: "cover",
																		borderRadius: 4,
																		border: "1px solid #eee",
																	}}
																/>
															) : (
																<span style={{ color: "#aaa", fontSize: 12 }}>
																	No preview
																</span>
															)}
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</Col>
							</Row>
						)}
						<Divider />
						<Card
							title={<span style={{ fontSize: "14px" }}>Created By</span>}
							className=''
							// style={{ border: "none"}}
							style={{
								border: "none",
								pageBreakBefore: "always",
								margin: "-10px",
							}}
						>
							{data && data.created_by && (
								<>
									<Row gutter={[8, 8]} className=''>
										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Created At</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.created_at}{" "}
											</Tag>
										</Col>

										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Name</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.created_by.name}{" "}
											</Tag>
										</Col>

										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Department:</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.department.name}{" "}
											</Tag>
										</Col>
									</Row>
								</>
							)}
						</Card>
						<Card
							title={
								<span
									style={{
										fontSize: "14px",
										display: "block",
										textAlign: "center",
									}}
								>
									Approvers
								</span>
							}
							className=''
							style={{
								border: "none",
							}}
						>
							<Row gutter={[16, 16]}>
								<Col span={24}>
									<div style={{ overflowX: "auto", marginTop: 8 }}>
										<table
											style={{
												width: "100%",
												borderCollapse: "collapse",
												fontSize: 13,
											}}
										>
											<thead>
												<tr style={{ background: "#f5f5f5" }}>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Group
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Name
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Status
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Action Performed At
													</th>
												</tr>
											</thead>
											<tbody>
												{Array.isArray(data?.approvers) &&
												data.approvers.length > 0 ? (
													data.approvers.flatMap((group) => {
														const respondedUsers = Array.isArray(group.users)
															? group.users.filter(
																	(approver) =>
																		approver.responded_by &&
																		approver.id &&
																		approver.responded_by.id === approver.id
															  )
															: [];

														if (respondedUsers.length === 0) {
															return [];
														}

														return respondedUsers.map((approver, uidx) => (
															<tr key={`${group.id}-${approver.id || uidx}`}>
																{uidx === 0 && (
																	<td
																		rowSpan={respondedUsers.length}
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																			fontWeight: "bold",
																			background: "#fafafa",
																			verticalAlign: "top",
																		}}
																	>
																		{group.name || "-"}
																	</td>
																)}
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.name || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status_at || "-"}
																</td>
															</tr>
														));
													})
												) : (
													<tr>
														<td
															colSpan={4}
															style={{ padding: 8, textAlign: "center" }}
														>
															No approvers found.
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</Col>
							</Row>
						</Card>
						<Divider />
						{data &&
							data.quality_assurances &&
							data.quality_assurances.length > 0 && (
								<>
									<Divider />
									<Card
										title={
											<span
												style={{
													fontSize: "14px",
													display: "block",
													textAlign: "center",
												}}
											>
												Quality Assurance Details
											</span>
										}
										className=''
										style={{
											border: "none",
										}}
									>
										<Row gutter={[16, 16]}>
											<Col span={24}>
												<div style={{ overflowX: "auto", marginTop: 8 }}>
													<table
														style={{
															width: "100%",
															borderCollapse: "collapse",
															fontSize: 13,
														}}
													>
														<thead>
															<tr style={{ background: "#f5f5f5" }}>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	QA User
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Status
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Testing Type
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Status At
																</th>
																<th
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	Feedback
																</th>
															</tr>
														</thead>
														<tbody>
															{data.quality_assurances.map((qa) => (
																<tr key={qa.id}>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.qa_user?.name || "Unassigned"}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.status ? (
																			<Tag
																				color={
																					qa.status === "Modification Required"
																						? "orange"
																						: "green"
																				}
																			>
																				{qa.status}
																			</Tag>
																		) : (
																			<Tag>Pending</Tag>
																		)}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.testing_type || "-"}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.status_at || "-"}
																	</td>
																	<td
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																		}}
																	>
																		{qa.feedback ? (
																			<div
																				dangerouslySetInnerHTML={{
																					__html: replaceLineBreaks(
																						qa.feedback
																					),
																				}}
																			/>
																		) : (
																			"-"
																		)}
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</Col>
										</Row>
									</Card>
								</>
							)}
						<Divider />
						{data && data.deployments && data.deployments.length > 0 && (
							<>
								<Card
									title={
										<span
											style={{
												fontSize: "14px",
												display: "block",
												textAlign: "center",
											}}
										>
											Deployment Details
										</span>
									}
									className=''
									style={{
										border: "none",
									}}
								>
									<Row gutter={[16, 16]}>
										<Col span={24}>
											<div style={{ overflowX: "auto", marginTop: 8 }}>
												<table
													style={{
														width: "100%",
														borderCollapse: "collapse",
														fontSize: 13,
													}}
												>
													<thead>
														<tr style={{ background: "#f5f5f5" }}>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Deployment No
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Created By
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Created At
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Document No
															</th>
															<th
																style={{ padding: 8, border: "1px solid #eee" }}
															>
																Details
															</th>
														</tr>
													</thead>
													<tbody>
														{data.deployments.map((deployment) => (
															<React.Fragment key={deployment.id}>
																{deployment.deployment_details.map(
																	(detail, index) => (
																		<tr key={`${deployment.id}-${detail.id}`}>
																			{index === 0 && (
																				<>
																					<td
																						rowSpan={
																							deployment.deployment_details
																								.length
																						}
																						style={{
																							padding: 8,
																							border: "1px solid #eee",
																							fontWeight: "bold",
																							background: "#fafafa",
																							verticalAlign: "top",
																						}}
																					>
																						{deployment.sequence_no}
																					</td>
																					<td
																						rowSpan={
																							deployment.deployment_details
																								.length
																						}
																						style={{
																							padding: 8,
																							border: "1px solid #eee",
																							verticalAlign: "top",
																						}}
																					>
																						{deployment.created_by.name}
																					</td>
																					<td
																						rowSpan={
																							deployment.deployment_details
																								.length
																						}
																						style={{
																							padding: 8,
																							border: "1px solid #eee",
																							verticalAlign: "top",
																						}}
																					>
																						{deployment.created_at}
																					</td>
																				</>
																			)}
																			<td
																				style={{
																					padding: 8,
																					border: "1px solid #eee",
																				}}
																			>
																				{detail.document_no}
																			</td>
																			<td
																				style={{
																					padding: 8,
																					border: "1px solid #eee",
																				}}
																			>
																				{detail.detail}
																			</td>
																		</tr>
																	)
																)}
															</React.Fragment>
														))}
													</tbody>
												</table>
											</div>
										</Col>
									</Row>
								</Card>
							</>
						)}
						<Divider />
						<Row gutter={[16, 16]}>
							<Col span={24} style={{ fontSize: 12, marginTop: 16 }}>
								This document has been approved through the system-based
								workflow.
								<br />
								Detailed information for SCRF ID: {id} can be accessed from this
								link.{" "}
								<a
									href={window.location.href}
									target='_blank'
									rel='noopener noreferrer'
								>
									View Details
								</a>
							</Col>
						</Row>
					</Card>
				)}
				{/* Print End*/}

				<Card style={{ minHeight: "100vh" }} id='qqq'>
					<Row gutter={[24, 24]}>
						<Col lg={5} md={5} sm={7} xs={7}>
							<CreatedByComponent data={data} />
							<Button
								type='primary'
								onClick={handlePrintClick}
								style={{
									marginTop: "20px",
									marginBottom: "20px",
									width: "100%",
								}}
							>
								Print Document
							</Button>
							{data &&
								(data.status === "Pending" || data.status === "Approved") &&
								Isadmin === true && (
									<AddApproversComponent data={data && data} formId={formId} />
								)}
							{/*<ApproversComponent approvers={data && filteredApprovers} />*/}
							<ApproversComponent approvers={data && data.approvers} />
						</Col>

						<Col lg={19} md={19} sm={17} xs={17}>
							<div>
								{data?.assigned_task?.assign_task_teams[0]?.members?.some(
									(m) => m.start_at && m.due_at
								) && (
									<TaskModal
										title='Tasks Logs'
										data_tasks={data.assigned_task.assign_task_teams[0].members}
										style={{ marginright: "0" }}
									/>
								)}
								{data?.approved_disapproved === true && (
									<div
										style={{
											position: "sticky",
											top: 1,
											zIndex: 999,
											background: "#fff",
											padding: "5px",
											borderRadius: "4px",
										}}
									>
										<Spin spinning={loading}>
											{data?.task_status?.id !== null && (
												<FeedbackModal
													title='QA Feedback'
													formId={formId}
													assurable_id={id}
													style={{ marginright: "0" }}
												/>
											)}
											<b>Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, false)}
												loading={loading}
												setStatus={setStatus}
											/>
										</Spin>
									</div>
								)}

								{data?.parallel_approved_disapproved === true && (
									<div
										style={{
											position: "sticky",
											top: data?.approved_disapproved ? "150px" : "1px", // Adjust the top value as needed
											zIndex: 999,
											background: "#fff", // Add a background color
											padding: "5px", // Add padding for better visual separation
											borderRadius: "4px", // Optional: Add rounded corners
										}}
									>
										<Spin spinning={loading}>
											<b>Parallel Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, true)}
												loading={loading}
												setStatus={setStatus}
												parallel={true}
												parallelUsers={
													data && data.parallel_approved_disapproved_users
												}
												setAssignedUserId={setAssignedUserId}
												reloadData={getSapById}
											/>
										</Spin>
									</div>
								)}

								<div className='mb-10'>
									{data?.assigned_task_to_me === true && (
										<div
											style={{
												position: "sticky",
												top: "1px",
												zIndex: 999,
												background: "#fff", // Add a background color
												padding: "5px", // Add padding for better visual separation
												borderRadius: "4px", // Optional: Add rounded corners
											}}
										>
											<TaskStatus
												data={data}
												reloadData={getSapById}
												formId={formId}
											/>
										</div>
									)}
								</div>

								{data && data.request_title && (
									<Card title='Basic Information' className='mb-10'>
										<Row gutter={[16, 16]}>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Sequence No</p>
												<Tag>{data.sequence_no}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Request Title</p>
												<Tag>{data.request_title}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Location</p>
												{data?.data?.location?.map((location) => {
													const matchedLocation = locationOptions.find(
														(option) =>
															Number(option.id) === Number(location.id)
													);

													return (
														<Tag key={location.id}>
															{matchedLocation
																? matchedLocation.name
																: "Unknown Location"}
														</Tag>
													);
												})}
											</Col>
											{/* {data.task_status?.name && ( */}
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Task Status</p>
												<Tag>{data.task_status?.name ?? "-"}</Tag>
											</Col>
											{/* )} */}
										</Row>
										<Row gutter={[16, 16]} className='mt-20'>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>For Email</p>
												<Tag>{data.for_email}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>For Department</p>
												<Tag>{data?.for_department}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>For Designation</p>
												<Tag>{data?.for_designation}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>For Employee</p>
												<Tag>{data?.for_employee}</Tag>
											</Col>
										</Row>
										<Row gutter={[16, 16]} className='mt-20'>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Company</p>
												<Tag>{data.company?.name}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Type</p>
												<Tag>
													{data.type}{" "}
													{data.type !== "New" ? `: (${data.sap_id})` : ""}
												</Tag>
											</Col>

											{data && data.assigned_task?.start_at && (
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10 bold'>Start Date</p>
													<Tag>{data.assigned_task?.start_at}</Tag>
												</Col>
											)}
											{data && data.assigned_task?.due_at && (
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10 bold'>Deadline</p>
													<Tag>{data.assigned_task?.due_at}</Tag>
												</Col>
											)}

											{data.type && data.type === "Modification" && (
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10 bold'>ID</p>
													<Tag>{data.sap_id}</Tag>
												</Col>
											)}
										</Row>
									</Card>
								)}

								{data && (
									<Card
										title='Required ID & Access on Module(s)'
										className='mb-10'
									>
										<Row gutter={[16, 16]} className='mt-20'>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Roles Required</p>
												<Tag>{data?.roles_required}</Tag>
											</Col>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>T.Code Required</p>
												<Tag>{data?.tcode_required}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>Plant</p>
												{data?.data?.plant?.map((plant) => {
													const matchedPlant = plantOptions.find(
														(option) => Number(option.id) === Number(plant.id)
													);
													return (
														<Tag key={plant.id}>
															{matchedPlant
																? matchedPlant.name
																: "Unknown plant"}
														</Tag>
													);
												})}
											</Col>
										</Row>

										<Row gutter={[16, 16]} className='mt-20'>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10 bold'>
													Business Justification
												</p>
												<Tag>{data.business_justification}</Tag>
											</Col>
										</Row>
									</Card>
								)}

								{renderSection(
									"Sales Distribution",
									data?.data?.sales_distribution,
									[
										{ key: "sales_organization", label: "Sales Organization" },
										{
											key: "distribution_channel",
											label: "Distribution Channel",
										},
										{ key: "division", label: "Division" },
										{ key: "sales_office", label: "Sales Office" },
										{ key: "sales_group", label: "Sales Group" },
										{ key: "other_details", label: "Other Details" },
									]
								)}
								{renderSection(
									"Material Management",
									data?.data?.material_management,
									[
										{ key: "purchasing_org", label: "Purchasing Org" },
										{ key: "purchasing_group", label: "Purchasing Group" },
										{ key: "storage_location", label: "Storage Location" },
										{
											key: "purchasing_document",
											label: "Purchasing Document",
										},
										{ key: "movement_type", label: "Movement Type" },
										{ key: "other_details", label: "Other Details" },
									]
								)}
								{renderSection(
									"Plant Maintenance",
									data?.data?.plant_maintenance,
									[
										{ key: "planning_plant", label: "Planning Plant" },
										{ key: "maintenance_plant", label: "Maintenance Plant" },
										{ key: "work_centers", label: "Work Centers" },
										{ key: "other_details", label: "Other Details" },
									]
								)}
								{renderSection(
									"Financial Accounting & Costing",
									data?.data?.financial_accounting_costing,
									[
										{ key: "profile_center", label: "Profile Center" },
										{ key: "cost_center", label: "Cost Center" },
										{ key: "other_details", label: "Other Details" },
									]
								)}
								{renderSection(
									"Production Planning",
									data?.data?.production_planning,
									[{ key: "other_details", label: "Other Details" }]
								)}
								{renderSection("Human Resource", data?.data?.human_resource, [
									{ key: "personnel_area", label: "Personnel Area" },
									{ key: "sub_area", label: "Sub Area" },
									{ key: "cost_center", label: "Cost Center" },
									{ key: "employee_group", label: "Employee Group" },
									{ key: "employee_sub_group", label: "Employee Sub Group" },
									{ key: "other_details", label: "Other Details" },
								])}

								{data && data.attachments && data.attachments.length > 0 ? (
									<Card title='Attachments' className='mb-10'>
										<table
											style={{ width: "100%", borderCollapse: "collapse" }}
										>
											<thead>
												<tr>
													<th
														style={{
															textAlign: "left",
															padding: 8,
															borderBottom: "1px solid #eee",
														}}
													>
														Title
													</th>
													<th
														style={{
															textAlign: "left",
															padding: 8,
															borderBottom: "1px solid #eee",
														}}
													>
														Preview
													</th>
													<th
														style={{
															textAlign: "left",
															padding: 8,
															borderBottom: "1px solid #eee",
														}}
													>
														Action
													</th>
												</tr>
											</thead>
											<tbody>
												{Array.isArray(data.attachments) &&
													data.attachments.map((attachment) => {
														const isImage = (filename) =>
															/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
														const fileUrl = attachment.filename;
														const fileTitle =
															getFileNameFromPath(attachment.original_title) ||
															getFileNameFromPath(attachment.filename);
														return (
															<tr key={attachment.id}>
																<td
																	style={{
																		padding: 8,
																		verticalAlign: "middle",
																	}}
																>
																	{fileTitle}
																</td>
																<td
																	style={{
																		padding: 8,
																		verticalAlign: "middle",
																	}}
																>
																	{isImage(fileUrl) ? (
																		<a
																			href={fileUrl}
																			target='_blank'
																			rel='noopener noreferrer'
																			title='Preview image'
																		>
																			<img
																				src={fileUrl}
																				alt={fileTitle}
																				style={{
																					width: 40,
																					height: 40,
																					objectFit: "cover",
																					borderRadius: 4,
																					border: "1px solid #eee",
																					boxShadow:
																						"0 1px 4px rgba(0,0,0,0.08)",
																				}}
																			/>
																		</a>
																	) : (
																		<span
																			style={{ color: "#aaa", fontSize: 12 }}
																		>
																			No preview
																		</span>
																	)}
																</td>
																<td
																	style={{
																		padding: 8,
																		verticalAlign: "middle",
																	}}
																>
																	<Button
																		size='small'
																		className='mb-10'
																		type='primary'
																		onClick={() => downloadFile(fileUrl)}
																	>
																		Download
																	</Button>
																</td>
															</tr>
														);
													})}
											</tbody>
										</table>
									</Card>
								) : (
									<>
										<div></div>
									</>
								)}
							</div>

							<CommentSystem
								id={id}
								form_id={7}
								status={data && data.status}
								comment_status={data && canComment}
							/>
						</Col>
					</Row>
				</Card>
			</Spin>
		</DefaultLayout>
	);
};

export default SapDetails;
